// @flow

import React, { type Node } from 'react';
import { Helmet } from 'react-helmet';
import faviconSrc from '@tectonics/favicon.svg';
import { type LookAndFeelRootPropsPendingPayment } from '@tectonics/look-and-feel';
import { FormStatusContextProvider } from '@tectonics/prs/form-status';
import { getLookAndFeel, getName } from '@tectonics/prs/merchant';
import { PaymentSpecProvider } from '@tectonics/prs/payment-spec';
import { UserInputValuesProvider } from '@tectonics/prs/user-input-values';
import { GlobalStyle } from '../../commons/global-style';
import { SideDisplay } from '../../organisms/side-display';
import { LayoutBase, LayoutSideLeft, LayoutSideRight, MainPanel, MainPanelContent } from '../../template';
import { Header } from './header';
import { PageContent } from './page-content';

import {
  getMerchant,
  AutoRedirectComponent,
  IncomingPaymentProvider,
  ReloadAfterPaymentGetsConfirmedComponent,
} from '@tectonics/prs/incoming-payment';
import { translate } from '@tectonics/translate';

export function PagePendingPayment({
  spec,
  incomingPayment,
  userInputValues,
  onUserInput,
}: LookAndFeelRootPropsPendingPayment ): Node {
  const merchant = getMerchant(incomingPayment);
  const lookAndFeel = getLookAndFeel(merchant);
  const title = translate(`${lookAndFeel}.paymentPageTitle`) ?? 'Página de pagamento';

  return (
    <PaymentSpecProvider spec={spec}>
      <IncomingPaymentProvider incomingPayment={incomingPayment}>
        <FormStatusContextProvider>
          <UserInputValuesProvider
            values={userInputValues}
            setValue={onUserInput}
          >

            <Helmet>
              <title>{title}{merchant && ` - ${getName(merchant)}`}</title>
              <link rel="icon" href={faviconSrc} />
            </Helmet>

            <AutoRedirectComponent />
            <ReloadAfterPaymentGetsConfirmedComponent />

            <GlobalStyle />
            <Layout />

          </UserInputValuesProvider>
        </FormStatusContextProvider>
      </IncomingPaymentProvider>
    </PaymentSpecProvider>
  );
}

function Layout(): Node {
  return (
    <LayoutBase data-test-id="page-pending-payment">

      <LayoutSideLeft>
        <MainPanel>
          <Header />
          <MainPanelContent>
            <PageContent />
          </MainPanelContent>
        </MainPanel>
      </LayoutSideLeft>

      <LayoutSideRight>
        <SideDisplay />
      </LayoutSideRight>

    </LayoutBase>
  );
}
